<div class="container-fluid pt-2">
  <div class="animated fadeIn   mb-3">
    <div class="row">
      <div class="col-12 col-md-3">
          <mat-form-field class="w-100" [formGroup]="TextSearch">
              <mat-label>Search</mat-label>
              <input type="text" matInput formControlName="term" (keyup)="searchText()">
              <button mat-button *ngIf="TextSearch.controls['term'].value" matSuffix mat-icon-button aria-label="Clear" (click)="clearTextSearch()">
                  <mat-icon>close</mat-icon>
              </button>
          </mat-form-field>
      </div>
    </div>
  
  
      <!-- <div class="col-12 col-md-3">
          <mat-form-field class="w-100" [formGroup]="TextSearch">
              <input type="text" matInput formControlName="term" placeholder="Search" (keyup)="searchText()">
              <mat-icon matSuffix *ngIf="!term.value">search</mat-icon>
              <button mat-button *ngIf="term.value" matSuffix mat-icon-button aria-label="Clear"
                  (click)="clearTextSearch()">
                  <mat-icon>close</mat-icon>
              </button>
          </mat-form-field>
      </div> -->
  
    <div  class="animated zoomIn table-responsive ">
      <table class="table table-hover table-condensed table-lt-grey width-auto">
        <thead class="cbob-blue-thead table-bordered sticky-header">
          <tr class="headings">
            <th (click)="orderBy('securityID')" [class.sort-up]="orderByService.sortBy==='securityIDup'" [class.sort-down]="orderByService.sortBy==='securityIDdown'"
              class="hwidth">
              Security ID
            </th>
            <th (click)="orderBy('applicationDate')" [class.sort-up]="orderByService.sortBy==='applicationDateup'" [class.sort-down]="orderByService.sortBy==='applicationDatedown'"
              class="hwidth">
              Application Date
            </th>
            <th (click)="orderBy('applicationAmount')" [class.sort-up]="orderByService.sortBy==='applicationAmountup'" [class.sort-down]="orderByService.sortBy==='applicationAmountdown'"
              class="hwidth">
              Application Amount
            </th>
            <th (click)="orderBy('applicationStatus')" [class.sort-up]="orderByService.sortBy==='applicationStatusup'" [class.sort-down]="orderByService.sortBy==='applicationStatusdown'"
              class="hwidth ">
              Status
            </th>
            <th (click)="orderBy('acceptanceDetails')" [class.sort-up]="orderByService.sortBy==='acceptanceDetailsup'" [class.sort-down]="orderByService.sortBy==='acceptanceDetailsdown'"
              class="hwidth">
              Acceptance Details
            </th>
            <th (click)="orderBy('amountAccepted')" [class.sort-up]="orderByService.sortBy==='amountAcceptedup'" [class.sort-down]="orderByService.sortBy==='amountAccepteddown'"
              class="hwidth">
              Amount Accepted
            </th>
            <th (click)="orderBy('refundDetails')" [class.sort-up]="orderByService.sortBy==='refundDetailsup'" [class.sort-down]="orderByService.sortBy==='aprefundDetailsdown'"
              class="hwidth">
              Refund Details
            </th>

          </tr>
        </thead>
        <tr *ngFor="let item of audit" (click)="makeActive(item)" [class.active]="item===active">
          <td [class.highlight]="orderByService.sortBy==='securityIDup'||orderByService.sortBy==='securityIDdown'">
            <span class="category">Security ID:
              <br class="no-style-break">
            </span>
            <span>{{item.securityID}}</span>
          </td>
          <td [class.highlight]="orderByService.sortBy==='applicationDateup'||orderByService.sortBy==='applicationDatedown'">
            <span class="category">Application Date:
              <br class="no-style-break">
            </span>
            <span>{{item.applicationDate | date: 'MM/dd/yyyy'}}</span>
          </td>
          <td [class.highlight]="orderByService.sortBy==='applicationAmountnup'||orderByService.sortBy==='applicationAmountdown'">
            <span class="category"> Application Amount:
              <br class="no-style-break">
            </span>
            <span>{{item.applicationAmount |  number:'1.2-3'}}</span>
          </td>
          <td  [class.highlight]="orderByService.sortBy==='applicationStatusup'||orderByService.sortBy==='applicationStatusdown'">
            <span class="category">Status:
              <br class="no-style-break">
            </span>
            <span>{{item.applicationStatus}}</span>
          </td> 
          <td  [class.highlight]="orderByService.sortBy==='acceptanceDetailsup'||orderByService.sortBy==='acceptanceDetailsdown'">
            <span class="category">Acceptance Details:
              <br class="no-style-break">
            </span>
            <!-- <span>{{item.acceptanceDetails}}</span> -->
            <span>{{item.applicationDate | date: 'MM/dd/yyyy'}}</span>
          </td> 
          <td  [class.highlight]="orderByService.sortBy==='amountAcceptedup'||orderByService.sortBy==='amountAccepteddown'">
            <span class="category">Amount Accepted:
              <br class="no-style-break">
            </span>
          <!--   <span>{{item.amountAccepted |  number:'1.2-3'}}</span> -->
          <span>{{item.applicationAmount |  number:'1.2-3'}}</span>
          </td> 
          <td  [class.highlight]="orderByService.sortBy==='refundDetailsup'||orderByService.sortBy==='refundDetailsdown'" >
            <span class="category">Refund Details:
              <br class="style-break">
            </span>
            <span>{{item.refundDetails}}</span>
          </td>        
        </tr>
      </table>
    </div>
    </div>
    <div > 
      <pagination></pagination>
      <!-- <mat-paginator></mat-paginator> -->
  </div>
  <div *ngIf="totalEntries === 0 && loadingData === true">No Entries Found</div>
</div>

  <div style="width: 100%;" [hidden]="loadingData">
      <br>
      <mat-spinner style="margin:0 auto;" class="pink-spinner .mat-spinner-bar-buffer" mode="indeterminate"></mat-spinner>
      <br>
      <br>
      <br>
  </div>



    



 

